import { get } from 'lodash';
import { pruneFieldErrors } from '@/utils/errors';
import findResult, { hasKey } from '@/utils/resultsHelper';
import pagingWithFilteredResults, { presentationOptions } from '@/constants/states';
import fields from '@/constants/fields';
import { themeStates } from '../constants';

export const activeTheme = () => ({
  open: false,
  code: null,
  name: '',
  description: '',
  enabled: true,
  ...themeStates,
});

export const newThemeProperties = (item, action) => ({
  ...item,
  code: action.code,
  category: action.category,
  open: true,
  ...themeStates,
});

const allThemes = (display = presentationOptions.TABLE) => (
  {
    all: {
      ...pagingWithFilteredResults(),
      ...themeStates,
      display,
    },
  }
);

const initialState = {
  theme: 'default',
  activeTheme: { ...activeTheme() },
  images: [],
  themes: {
    ...allThemes(),
    ribbon: {
      params: { enabled: true },
      ...pagingWithFilteredResults(1000),
      ...themeStates,
    },
  },
};

export const pruneThemeErrors = (errors, { properties }) => {
  let filteredErrors = errors;

  if (hasKey(properties, 'name')) {
    filteredErrors = pruneFieldErrors(filteredErrors, fields.NAME);
  }
  if (hasKey(properties, 'code')) {
    filteredErrors = pruneFieldErrors(filteredErrors, fields.CODE);
  }
  if (hasKey(properties, 'description')) {
    filteredErrors = pruneFieldErrors(filteredErrors, fields.DESCRIPTION);
  }

  return filteredErrors;
};

export const findThemes = ({ themes }, { category }) => themes[category];

export const findTheme = ({ themes }, { category, code }) => findResult(themes, category, code);

export const themeStateToLoad = ({ theme, themes }) => {
  const items = get(themes, 'themes', initialState.themes);
  const allFilters = items.all || initialState.themes.all;

  return {
    ...initialState,
    theme: theme || initialState.theme,
    themes: {
      ...initialState.themes,
      ...allThemes(allFilters.display),
    },
  };
};

export const themeStateToSave = ({ themes }) => (
  {
    theme: themes.theme,
    themes: {
      themes: {
        all: {
          display: themes.themes.all.display,
        },
      },
    },
  }
);

export default initialState;
